app.controller('teacherInfoCtrl', [
    function () {
    	var vm = this;
    }
]);
